module.exports = __webpack_public_path__ + "static/media/no_cardio.c14a5205.webp";